$("#go-to-page").click(function () {
    // Validate input value
    input_val = $('#goto_page_input').val();
    if (isNaN(input_val)) {
        const current_page = $('#goto_page_input').attr('data-current');
        $('#goto_page_id').val(current_page);
        return;
    }
    page = parseInt(input_val);
    max_page = $('#goto_page_input').attr('data-max');
    go2num = Math.min(max_page, page);
    go2num = Math.max(1, go2num);
    //Construct url
    url = $('#goto_page_input').attr('data-url');
    url = url.replace('-1', go2num);
    document.location.href = '?' + url;
});

$('#goto_page_input').keypress(function (e) {
    let key = e.which;
    if (key == 13)  // the enter key code
    {
        $("#go-to-page").click();
    }
});

$("#paginate_by").change(function () {
    let url = $(this).attr('data-paginate-url');
    url = url.replace('-99999', $(this).val()).replace(/&amp;/g, '&');
    document.location.href = '?' + url;
});
